import Button from '@/components/Button'
import Card from '@/components/Card'
import Layout, { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import StarRatingBadge from '@/widgets/StarRatingBadge'
import React from 'react'
import { CardPrimaryAction, GuideByline, LiveListRemind, VariantProps } from '../index'
import * as styles from '../style'
interface FooterProps {
  actionBlock?: React.ReactNode
  contentBlock?: React.ReactNode
}
const ClassFooter = ({ actionBlock, contentBlock }: FooterProps): JSX.Element => (
  <Layout>
    <Stack x alignItems="center">
      <>
        {contentBlock ? <Stack y>{contentBlock}</Stack> : null}
        {actionBlock ? actionBlock : null}
      </>
    </Stack>
  </Layout>
)

const Standard = ({
  canBookmark,
  canRemind,
  durationMinutes,
  footerContent,
  id,
  imageUrl,
  guideAvatarUrl,
  guideByline,
  rating,
  title,
  primaryAction,
  navigationAction,
  navigateToGuideAction,
  isLive,
  isCommunityLedClass = false,
  isEncore = false,
  livenessType,
}: Partial<VariantProps>): JSX.Element => (
  <Card
    theme="standard"
    overlay
    backgroundImage={imageUrl}
    href={navigationAction?.url}
    footer={
      footerContent ? (
        <ClassFooter
          contentBlock={footerContent}
          actionBlock={
            primaryAction?.label ? (
              <CardPrimaryAction primaryAction={primaryAction} navigationAction={navigationAction}>
                <Button
                  size="sm"
                  theme={
                    isLive ||
                    primaryAction?.__typename === 'JoinBookedSessionCardAction' ||
                    primaryAction?.__typename === 'JoinLiveSessionCardAction'
                      ? 'primary'
                      : 'secondary'
                  }
                  label={primaryAction.label}
                />
              </CardPrimaryAction>
            ) : null
          }
        />
      ) : null
    }
    data-id={id}
    isCommunityLedClass={isCommunityLedClass}
    isEncore={isEncore}
  >
    <Layout>
      <Stack y align-self="flex-start">
        <Stack x alignSelf="flex-start">
          <LiveListRemind {...{ isLive, canRemind, canBookmark }} />
        </Stack>

        <Stack y alignSelf="flex-end">
          <Stack x>
            <div>
              <Text tag="h2" weight="md" size="md" className="pb-sm">
                {title}
              </Text>
            </div>
            <Stack y alignSelf="flex-start" className={`${styles.meta} pt-sm pb-sm`}>
              {durationMinutes ? (
                <Text tag="span" size="xxxs" weight="sm">
                  {durationMinutes} mins
                </Text>
              ) : null}
              {rating ? (
                <div>
                  <StarRatingBadge value={rating} />
                </div>
              ) : null}
            </Stack>
          </Stack>
          <GuideByline {...{ guideAvatarUrl, guideByline, navigateToGuideAction, livenessType }} />
          {!!primaryAction && !footerContent ? (
            <CardPrimaryAction primaryAction={primaryAction} navigationAction={navigationAction}>
              <Button
                theme={
                  isLive ||
                  primaryAction?.__typename === 'JoinBookedSessionCardAction' ||
                  primaryAction?.__typename === 'JoinLiveSessionCardAction'
                    ? 'primary'
                    : 'secondary'
                }
                size="lg"
                label={primaryAction?.label}
                className="mt-sm"
              />
            </CardPrimaryAction>
          ) : null}
        </Stack>
      </Stack>
    </Layout>
  </Card>
)

export default Standard
